import React from "react";
import { Route } from "react-router-dom";
import ExamTimetables from "../page_content/examination_section/ExamTimetable";
import Notices from "../page_content/examination_section/Notices";
import Examinations from "../pages/Examinations";

export const ExaminationsRoutes= (
  <Route path="examinations" element={<Examinations />}>
       <Route path="notices" element={<Notices/>} />
    <Route path="exam-timetable" element={<ExamTimetables/>}/>
 
  </Route>
);
